import request from "@/common/request"
import { CartaDeCorrecao } from "@/models/fiscal/CartaDeCorrecao"
import { AxiosRequestConfig } from "axios"
import { Page } from "@/models/Page"

const basePath = '/carta-de-correcao'

export const criarCartaDeCorrecao = (params?: any): Promise<void> =>
	request.post(`${basePath}`, params )

export const findCartasDeCorrecao = (params?: any, config?: AxiosRequestConfig): Promise<Page<CartaDeCorrecao>> =>
	request.get(`${basePath}`, { params, ...config })



